<template>
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div class="login-body">
        <div class="login-wrapper">
            <div class="login-panel">
                <a class="logo">
                    <h3 style="color: #002; line-height: 0.5em">인증번호 입력</h3>
                    <p id="fpass">이메일로 전송된 OTP 인증번호를 입력해주세요.</p>
                </a>
                <InputText :class="`${error.otp ? 'p-invalid' : ''}`" id="otp" placeholder="인증번호 입력" v-model="otp" />
                <div class="text-redx">{{ error.otp }}</div>
                <!-- <div class="text-redx">{{ email_err }}</div> -->

                <Button label="비밀번호 재설정" type="button" @click="Login" class="colorchange"></Button>
                <!-- <a href="#" @click="open">{{ $t('Forget Password') }}</a> -->
                <!-- <a href="#">forget dfc password?</a> -->
                <!-- <p>Don’t you have an account, <a href="#">sign up</a></p> -->
            </div>
        </div>
    </div>
</template>

<script>
// import validateLogin from '../validations/validateLogin';
import validateOTP from '../validations/validateOTP';
// import validateReset from '../validations/validateReset';
import axios from 'axios';
export default {
    data() {
        return {
            errmsg: '',
            helptxt: true,
            resetemail: '',
            display: false,
            email_err: '',
            pass_err: '',
            code: '',
            otp: '',
            otpmatch: localStorage.getItem('otp'),

            error: {},
            errors: {},
            remember: true,
            email: localStorage.getItem('email'),
        };
    },
    mounted() {
        this.remember = localStorage.getItem('save') == 'true' ? true : false;
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },

        async Login() {
            localStorage.setItem('email', this.email);

            let credentials = {
                email: this.email,
                otp: this.otp,
            };

            const { isInvalid, error } = validateOTP(credentials);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                var self = this;
                this.error = {};
                // console.log('pass');
                await axios({
                    method: 'post',
                    url: 'api/v1/admin/user/verify-otp',
                    data: { email: this.email, otp: this.otp },
                })
                    .then(function (response) {
                        console.log(response)
                        if (response.data.message === 'verified') {
                            // localStorage.setItem('otp', response.data.otp);

                            self.$confirm.require({
                                message: 'OTP가 인증되었습니다.',
                                // icon: 'pi pi-exclamation-triangle',
                                header: '발송 완료',
                                acceptLabel: '확인',
                                rejectLabel: '취소',
                                accept: () => {
                                    self.$toast.add({ severity: 'info', summary: '확인', detail: 'OTP 성공적으로 일치', life: 3000 });
                                    setTimeout(() => {
                                        self.$router.push({ name: 'changepassword' });
                                    }, 1000);
                                },
                                reject: () => {
                                    self.$toast.add({ severity: 'error', summary: '거부됨', detail: 'You have rejected', life: 3000 });
                                },
                            });
                        }else if(response.data.message === 'expiredotp')
                        {
                            self.$toast.add({ severity: 'error', summary: '거부됨', detail: '인증번호가 만료되었습니다.', life: 3000 });
                            self.$router.push({ name: 'forgotpassword' });
                        }else{
                            self.$toast.add({ severity: 'error', summary: '거부됨', detail: '인증번호가 일치하지 않습니다.', life: 3000 });
                        }
                    })
                    .catch(() => {
                        self.$toast.add({ severity: 'info', summary: '확인', detail: "사용자가 존재하지 않습니다.", life: 3000 });
                    });

            }
        },
        // async Login() {
        //     if (this.otpmatch == this.otp) {
        //         let credentials = {
        //             otp: this.otp,
        //             // email: this.email,
        //         };
        //         const { isInvalid, error } = validateOTP(credentials);
        //         if (isInvalid) {
        //             this.error = error;
        //             console.log(error);
        //         } else {
        //             var self = this;
        //             self.error = {};
        //             // console.log('pass');

        //             self.$toast.add({ severity: 'info', summary: '확인', detail: 'OTP 성공적으로 일치', life: 3000 });
        //             setTimeout(() => {
        //                 self.$router.push({ name: 'changepassword' });
        //             }, 1000);
        //         }


        //     }
        //     else if (this.otpmatch !== this.otp) {
        //         this.$toast.add({ severity: 'info', summary: '확인', detail: 'OTP가 일치하지 않음', life: 3000 });
        //     }
        // },

        goDashboard() {
            window.location = '/';
        },
    },
};
</script>
<style scoped>
.colorchange:focus {
    background-color: #fff;
    color: blue;
}
p#fpass {
    font-weight: 400;
    color: black;
    font-size: 14px;
}
</style>